import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBed"><Path d="M4 6.5C4 5.11929 5.11929 4 6.5 4H11.5V10H4V6.5Z" fill="currentColor"/><Path d="M12.5 10V4H17.5C18.8807 4 20 5.11929 20 6.5V10H12.5Z" fill="currentColor"/><Path d="M22 13.5C22 12.1193 20.8807 11 19.5 11H4.5C3.11929 11 2 12.1193 2 13.5V16.5C2 17.3284 2.67157 18 3.5 18H4V19.5C4 19.7761 4.22386 20 4.5 20C4.77614 20 5 19.7761 5 19.5V18H19V19.5C19 19.7761 19.2239 20 19.5 20C19.7761 20 20 19.7761 20 19.5V18H20.5C21.3284 18 22 17.3284 22 16.5V13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBed;
